import React from 'react';
import { Box, Skeleton } from '@mui/material';

import { styles } from './ApiKeyUtil';

const ApiKeySkeleton = () => (
  <Box sx={styles.skeleton.container}>
    <Box>
      <Skeleton variant="text" width={150} height={24} sx={styles.skeleton.textLarge} />
      <Skeleton variant="text" width={100} height={18} />
      <Skeleton variant="text" width={80} height={18} sx={styles.skeleton.textSmall} />
    </Box>
    <Skeleton variant="circular" width={24} height={24} />
  </Box>
);

export default ApiKeySkeleton;
